import { render, staticRenderFns } from "./speech-area.vue?vue&type=template&id=5d80d0f6"
import script from "./speech-area.vue?vue&type=script&lang=js"
export * from "./speech-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports